<template>
    <div class="crisisearlywarn">
        <div class="header">
            <div>
                <div class="item">{{$t('original.Name_of_scale')}}：
                    <el-input v-model="params.from.scaleName" clearable :placeholder="$t('original.languages563')" style="width: auto;"></el-input>
                </div>
                <div class="item">
                    {{$t('original.languages562')}}：
                    <el-date-picker  clearable  v-model="params.from.testTime"  type="daterange"  :range-separator="$t('original.languages296')"  :start-placeholder="$t('original.languages346')"  :end-placeholder="$t('original.languages347')">
                    </el-date-picker>
                </div>
                <div class="item">{{$t('original.gender')}}：
                    <el-select v-model="params.sex" clearable :placeholder="$t('original.languages3')" >
                        <el-option :label="$t('original.languages6')" :value="0"></el-option>
                        <el-option :label="$t('original.languages5')" :value="1"></el-option>
                    </el-select>
                </div>
            </div>
            <div>
                <div class="item" style="width:auto;">
                <span>{{$t('original.languages144')}}：</span>
                <el-checkbox-group v-model="params.from.warning" clearable style="display: inline-block;">
                    <el-checkbox label="重度">{{$t('original.languages129')}}</el-checkbox>
                    <el-checkbox label="较重">{{$t('original.languages580')}}</el-checkbox>    
                    <el-checkbox label="中度">{{$t('original.languages130')}}</el-checkbox>
                    <el-checkbox label="轻度">{{$t('original.languages131')}}</el-checkbox>
                    <el-checkbox label="正常">{{$t('original.languages47')}}</el-checkbox>
                </el-checkbox-group>
            </div>
            <el-button type="primary" @click="search">{{$t('original.languages470')}}</el-button>
            <el-button @click="reset">{{$t('original.reset')}}</el-button>
            </div>
        </div>
        <div class="content">
            <el-button type="primary" style="margin-bottom: 20px;" @click="clickexport">{{$t('original.languages154')}}</el-button>
            <el-table style="width: 100%;" :data="queryscaletestData" v-loading="loading" @selection-change="handleSelectionChange">
                <el-table-column type="selection" width="50"></el-table-column>
                <el-table-column type="index" :label="$t('original.The_serial_number')" width="50">
                    <template slot-scope="scope" center>
                        {{ (params.pageIndex - 1) * 10 + scope.$index + 1 }}
                    </template>
                </el-table-column>
                <el-table-column  prop="RealName" :label="$t('original.name')"></el-table-column>
                <el-table-column  prop="Sex" :label="$t('original.gender')"></el-table-column>
                <el-table-column  prop="Birthday" :label="$t('original.languages256')"></el-table-column>
                <el-table-column  prop="TheEntranceDate" :label="$t('original.languages171')"></el-table-column>
                <el-table-column  prop="DeptID" :label="$t('original.class_name')"></el-table-column>
                <el-table-column  prop="PaperName" :label="$t('original.Name_of_scale')"></el-table-column>
                <el-table-column  prop="PaperScoreR" :label="$t('original.languages565')"></el-table-column>
                <el-table-column  prop="PaperScoreS" :label="$t('original.languages566')"></el-table-column>
                <el-table-column  prop="WarningID" :label="$t('original.languages144')">
                    <template v-slot="scope">
                        <el-button type="primary" :style="{background:scope.row.WarningIDColor,border:'none'}">{{ scope.row.WarningID }}</el-button>
                    </template>
                </el-table-column>
                <el-table-column prop="SeTime" :label="$t('original.languages152')"></el-table-column>
                <el-table-column :label="$t('original.languages42')">
                    <template v-slot="scope">
                        <el-button type="text" @click="viewreport(scope.row)"  v-if="scope.row.Status == 1">{{$t('original.languages567')}}</el-button>
                    </template>
                </el-table-column>
            </el-table>

            <el-pagination @current-change="handleCurrentChange" hide-on-single-page  :current-page.sync="params.pageIndex" :page-size="params.pageSize" layout="total, prev, pager, next"  :total="params.Total">
            </el-pagination>
        </div>
    </div>
</template>
<script>
export default{
    name:'crisisearlywarn',
    data() {
        return {
            loading:true,
            params:{
                pageSize:10,
                pageIndex:1,
                Total:0,
                ifTest:1,
                ifSPublishID:[],
                sex:'',
                ifS:0,
                from:{
                    scaleName:'',
                    warning:[],
                    testTime:this.Global.querycensus(6)
                }
            },
            options: [{
                value: '选项1',
                label: '黄金糕'
                }, {
                value: '选项2',
                label: '双皮奶'
                }, {
                value: '选项3',
                label: '蚵仔煎'
                }, {
                value: '选项4',
                label: '龙须面'
                }, {
                value: '选项5',
                label: '北京烤鸭'
            }],
            queryscaletestData:[]
        }
    },
    created() {
        this.queryscaletestlist();
    },
    methods: {
        queryscaletestlist(){
            this.loading = true;
            this.$Http_Post('querypaper/querypapercrisiswarninglist',this.params).then(res=>{
                this.loading = false;
                if(res.Code == 200 || res.Code == 0){
                    if(this.params['ifS']==1){
                        this.params['ifS']=0;
                        location.href = res.Data;
                    }else{
                        this.queryscaletestData = res.Data;
                        this.params.Total = res.Counts;
                    }
                }else{
                    this.$message({type: 'error', message:res.Message});
                }
            })
        },
        // 查询
        search(){
            this.params.pageIndex = 1;
            this.queryscaletestlist();
        },
        // 重置
        reset(){
            this.params = this.$options.data().params;
        },
        // 导出
        clickexport(){
            if(this.params.ifSPublishID.length<=0){
                this.$message({type: 'error',message:"没有可导出的数据"});
                return false;
            }
            this.params['ifS']=1;
            this.queryscaletestlist();
        },
        // 分页
        handleCurrentChange(val){
            this.params.pageIndex=val;
            this.queryscaletestlist();
        },
        // 查看报告
        viewreport(e){
            location.href='/visitors/zReportnewShow?PaperResultID='+e.PaperResultID+'&ReportType=2'
        },
        handleSelectionChange(val){
            this.params.ifSPublishID = [];
            for(let item of val){
                this.params.ifSPublishID.push(item.PaperResultID);
            }
        }
    },
}
</script>
<style scoped>
.crisisearlywarn .header{background: #fff;padding: 20px 20px 0;}
.crisisearlywarn .header .item{display:inline-block;margin:0 30px 20px 0;}
.crisisearlywarn .content{padding:20px;background: #fff;margin-top: 20px;}
</style>